import { observer } from 'mobx-react';
import React from 'react';
import { Button, Notice, Separator, Text } from 'telia-front-react';
import LoginButton from '../components/LoginButton';
import { PASSKEY_NAME } from '../stores/PasskeyStore';
import useStores from '../stores/UseStores';
import { FetchStatus } from '../util/ApiUtil';
import { getStorage } from '../util/StorageUtil';

const PassKeyLogin = observer((): React.JSX.Element => {
  const {
    uiStore: { setSelectedTab },
    smartIdLoginStore,
    mobileIdLoginStore,
    passkeyStore,
    translateStore: { translate },
  } = useStores();

  if (getStorage().getItem(PASSKEY_NAME) && !passkeyStore.shouldShowPasskeyBindView) {
    return (
      <Text>
        <Separator />
        <LoginButton
          isLoading={passkeyStore.status === FetchStatus.FETCHING}
          onClick={() => {
            passkeyStore.authenticate();
          }}
        />
        <Button
          link={true}
          text={translate('passkey.add.new')}
          onClick={() => {
            passkeyStore.shouldShowPasskeyBindView = true;
          }}
        />
      </Text>
    );
  }

  return (
    <Text>
      <Separator />
      <Button
        block={true}
        text={translate('passkey.bind.with.mobileId')}
        iconRight="#arrow-right"
        onClick={() => {
          setSelectedTab('mobileId');
          mobileIdLoginStore.shouldSavePasskeyAfterLogin = true;
        }}
      />
      <Button
        block={true}
        text={translate('passkey.bind.with.smartId')}
        iconRight="#arrow-right"
        onClick={() => {
          setSelectedTab('smartId');
          smartIdLoginStore.shouldSavePasskeyAfterLogin = true;
        }}
      />
      <Notice size="small" type="info">
        {translate('passkey.login.notice')}
      </Notice>
      <Button
        link={true}
        text={translate('passkey.login.with.passkey')}
        onClick={() => {
          passkeyStore.shouldShowPasskeyBindView = true;
          passkeyStore.authenticate();
        }}
        iconRight="#arrow-right"
      />
    </Text>
  );
});

export default PassKeyLogin;
